/* ============================================================
   EY konfigurator v4 - bryla, rozmiar, tkanina, kolor, asystent,
   wlasciwosci, dodatki, podsumowanie.

   Zasada integracji: konfigurator NICZEGO nie dubluje. Klik w rozmiar albo
   kolor klika natywny input wariantu motywu, wiec galeria, cena, sticky bar
   i formularz aktualizuja sie mechanizmem Dawn i assets/ey-buybox.js.
   Wiersze Bryla i Tkanina to nawigacja: zwykle linki.

   Dodatki: konfigurator NIE dodaje nic do koszyka sam. Wystawia funkcje
   root.eyExtras() -> [{id, qty, price}], ktora assets/ey-buybox.js dolicza
   do ceny na CTA i doklada jako osobne pozycje przy /cart/add.js.

   Przeskok tkaniny albo bryly niesie KOLOR I ROZMIAR. Gdy po drugiej stronie
   nie ma obu, schodzimy na sam kolor. Gdy nie ma i koloru, wchodzimy w stan
   pusty (?ey_pick=1): zaznaczenie wyczyszczone, CTA nieaktywne, bez komunikatu.
   ============================================================ */
(function () {
  'use strict';

  function norm(s) {
    return String(s == null ? '' : s).trim().toLowerCase();
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  /* "jasny:Kremowy,Perlowy;szary:Grafit" -> { jasny:[...], szary:[...] } */
  function parseTones(raw) {
    var out = {};
    String(raw || '').split(';').forEach(function (chunk) {
      var i = chunk.indexOf(':');
      if (i < 1) return;
      var key = norm(chunk.slice(0, i));
      var vals = chunk.slice(i + 1).split(',').map(function (v) { return v.trim(); }).filter(Boolean);
      if (key && vals.length) out[key] = vals;
    });
    return out;
  }

  function splitList(raw) {
    return String(raw || '').split(',').map(function (v) { return v.trim(); }).filter(Boolean);
  }

  /* ZAWSZE dwa miejsca po przecinku - ten sam format co w bloku ceny u gory
     karty i w ey-buybox.js. Mieszanie „240 zl" i „240,00 zl" na jednym ekranie
     przy skanowaniu wzrokiem wyglada jak dwie rozne kwoty. */
  function money(cents) {
    var zl = cents / 100;
    try {
      return zl.toLocaleString('pl-PL', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }) + ' zł';
    } catch (e) {
      return zl.toFixed(2).replace('.', ',') + ' zł';
    }
  }

  function sztuk(n) {
    if (n === 1) return '1 sztuka';
    var last = n % 10, teen = n % 100;
    return n + ((last >= 2 && last <= 4 && (teen < 12 || teen > 14)) ? ' sztuki' : ' sztuk');
  }

  /* Wariant produktu docelowego dla biezacego koloru i rozmiaru.
     Najpierw probujemy trafic w oba, potem w sam kolor. Match po WARTOSCI,
     nie po nazwie opcji: poduszka ma "Kolor pokrycia", pufa "Kolor". */
  /* Z kilku pasujacych wariantow bierzemy NAJTANSZY, nie pierwszy z brzegu.
     Pierwszy z brzegu zalezy od kolejnosci wariantow w Shopify i przez to
     kafel „Lezanka Horizont od 520 zl" prowadzil w kolorze Kremowym na wariant
     140x90 za 580 zl, a w kazdym innym kolorze na 120x90 za 520 zl. Ten sam
     blad siedzial w dodatkach: cena kafla zmieniala sie z 520 na 580 po samej
     zmianie koloru pufy, bez slowa o tym, ze zmienil sie tez rozmiar.
     Najtanszy pasujacy zgadza sie z tym, co obiecuje etykieta „od X zl". */
  function cheapest(list) {
    var best = null, bestP = Infinity;
    list.forEach(function (v) {
      var p = typeof v.price === 'number' ? v.price : Infinity;
      if (best === null || p < bestP) { best = v; bestP = p; }
    });
    return best;
  }
  function pickVariant(target, col, siz) {
    var list = (target.variants || []).filter(function (v) { return v.ok; });
    if (!list.length) return null;
    var exact = list.filter(function (v) {
      var o = (v.opts || []).map(norm);
      if (col && o.indexOf(norm(col)) === -1) return false;
      if (siz && o.indexOf(norm(siz)) === -1) return false;
      return true;
    });
    if (exact.length) return cheapest(exact);
    if (!col) return null;
    var byColor = list.filter(function (v) {
      return (v.opts || []).some(function (o) { return norm(o) === norm(col); });
    });
    return byColor.length ? cheapest(byColor) : null;
  }

  /* Wariant TEGO produktu po kolorze i rozmiarze. Tu wymagamy obu, bo od tego
     zalezy cena w podsumowaniu. */
  function ownVariant(list, col, siz) {
    return (list || []).filter(function (v) {
      var o = (v.opts || []).map(norm);
      if (col && o.indexOf(norm(col)) === -1) return false;
      if (siz && o.indexOf(norm(siz)) === -1) return false;
      return v.ok;
    })[0] || null;
  }

  function init(root) {
    if (root.dataset.eyCfgInit) return;
    root.dataset.eyCfgInit = '1';

    var sectionId = root.dataset.sectionId || '';
    var colorOption = root.dataset.colorOption || 'Kolor';
    var sizeOption = root.dataset.sizeOption || '';
    var dataEl = root.querySelector('[data-ey-cfg-data]');
    var data = null;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { data = null; }
    if (!data) data = { current: {}, twins: [], shapes: [], self: { variants: [] }, addons: {}, lead: {} };

    var swatches = [].slice.call(scope().querySelectorAll('[data-ey-cfg-color]'));
    var sizeTiles = [].slice.call(scope().querySelectorAll('[data-ey-cfg-size]'));
    var nameOut = scope().querySelector('[data-ey-cfg-colorname]');
    var sizeOut = scope().querySelector('[data-ey-cfg-sizename]');

    /* ---------- numeracja krokow ----------
       Numer liczony z kolejnosci w DOM, nie w Liquidzie: od v6 kazda sekcja jest
       osobnym blokiem szablonu, a licznik increment resetuje sie w kazdym
       render. Dzieki temu przestawienie blokow w edytorze motywu przenumerowuje
       wiersze samo, bez dotykania kodu. */
    function numberSteps() {
      [].slice.call(scope().querySelectorAll('[data-ey-cfg-num]')).forEach(function (el, i) {
        el.textContent = String(i + 1);
      });
    }

    /* ---------- natywny selektor motywu ----------
       Szukamy w obrebie kolumny produktu, nie w calym dokumencie: na stronie bywa
       wiecej sekcji z radiami (quick add, polecane), a pomylka przelaczylaby
       nie ten produkt. */
    function scope() {
      return root.closest('.product__info-container') ||
             document.querySelector('.product__info-container') ||
             document;
    }
    function radiosFor(optName) {
      if (!optName) return [];
      return [].slice.call(scope().querySelectorAll('input[type="radio"]')).filter(function (r) {
        return norm(r.name).indexOf(norm(optName)) > -1;
      });
    }
    function selectFor(optName) {
      if (!optName) return null;
      return [].slice.call(scope().querySelectorAll('select')).filter(function (s) {
        var n = norm(s.name) + ' ' + norm(s.id);
        return n.indexOf(norm(optName)) > -1;
      })[0] || null;
    }
    function currentOf(optName) {
      var checked = radiosFor(optName).filter(function (r) { return r.checked; })[0];
      if (checked) return checked.value;
      var sel = selectFor(optName);
      if (sel && sel.value) return sel.value;
      return '';
    }
    function setOption(optName, value) {
      var radio = radiosFor(optName).filter(function (r) { return norm(r.value) === norm(value); })[0];
      if (radio) {
        if (!radio.checked) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        }
        return true;
      }
      var sel = selectFor(optName);
      if (sel) {
        var hit = [].slice.call(sel.options).filter(function (o) { return norm(o.value) === norm(value); })[0];
        if (hit) {
          sel.value = hit.value;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
          return true;
        }
      }
      return false;
    }

    /* Natywne pola koloru i rozmiaru chowamy, zeby nie bylo dwoch pickerow. */
    function hideNativeFields() {
      [].slice.call(scope().querySelectorAll('fieldset, .product-form__input')).forEach(function (box) {
        var legend = box.querySelector('legend, label');
        var txt = legend ? norm(legend.textContent) : '';
        if (txt.indexOf('kolor') > -1 || txt.indexOf('color') > -1 ||
            txt.indexOf('rozmiar') > -1 || txt.indexOf('size') > -1) {
          box.classList.add('ey-cfg-hidden-native');
        }
      });
    }

    /* Dawn przerenderowuje selektor wariantu po KAZDEJ zmianie opcji (Section
       Rendering API), wiec klasa ukrywajaca znika razem ze starym fieldsetem
       i natywny picker wraca pod podsumowaniem. Obserwator przywraca ukrycie.
       Mutacje wewnatrz .ey-cfg ignorujemy, zeby nie zapetlic obserwatora. */
    function watchNative() {
      var host = scope();
      if (!host || !window.MutationObserver) return;
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var t = muts[i].target;
          if (t && t.closest && t.closest('.ey-cfg')) continue;
          hideNativeFields();
          return;
        }
      }).observe(host, { childList: true, subtree: true });
    }

    /* ---------- stan pusty (?ey_pick=1) ---------- */
    var forcePick = /[?&]ey_pick=1/.test(window.location.search);

    /* forcePick czysci KOLOR, nie rozmiar. Brakujacym elementem po przeskoku
       jest zawsze kolor, rozmiar zostaje wybrany. */
    function activeColor() { return forcePick ? '' : currentOf(colorOption); }
    function activeSize() { return sizeOption ? currentOf(sizeOption) : ''; }

    function mainSubmit() {
      return document.getElementById('ProductSubmitButton-' + sectionId) ||
             scope().querySelector('.product-form__submit');
    }

    function lockCta(lock) {
      var btn = mainSubmit();
      if (!btn) return;
      if (lock) {
        if (!btn.dataset.eyCfgLabel) {
          var span = btn.querySelector('span');
          btn.dataset.eyCfgLabel = span ? span.textContent : btn.textContent;
        }
        btn.setAttribute('disabled', 'disabled');
        var s1 = btn.querySelector('span');
        if (s1) s1.textContent = 'Najpierw wybierz kolor';
      } else if (btn.dataset.eyCfgLabel) {
        btn.removeAttribute('disabled');
        var s2 = btn.querySelector('span');
        if (s2) s2.textContent = btn.dataset.eyCfgLabel;
        delete btn.dataset.eyCfgLabel;
      }
    }

    /* ---------- DODATKI ---------- */
    var addons = data.addons || {};
    /* KLUCZE DODATKOW: 'pod' oraz 'kom0', 'kom1', ... - po jednym na kazdy
       produkt z metapola dodatek_komplet. Wczesniej fotel i lezanka dzielily
       jeden kafel z przelacznikiem, przez co kafel mial o jeden wiersz wiecej
       niz sasiad i na waskim ekranie oba przestawaly byc rowne. Osobne kafle
       pokazuja tez od razu obie ceny, zamiast chowac druga za przelacznikiem. */
    var picked = {};

    function addonDef(key) {
      if (key === 'pod') return addons.pod || null;
      if (key.indexOf('kom') === 0) {
        var i = parseInt(key.slice(3), 10) || 0;
        return (addons.kom || [])[i] || null;
      }
      return null;
    }

    function addonKeys() {
      var keys = [];
      if (addons.pod) keys.push('pod');
      (addons.kom || []).forEach(function (k, i) { keys.push('kom' + i); });
      return keys;
    }

    /* ---------- przeniesienie dodatkow miedzy tkaninami ----------
       Zmiana tkaniny to przejscie na INNA karte produktu, wiec caly stan JS
       ginie. Klient, ktory zaznaczyl poduszke i fotel, po kliknieciu „Shaggy"
       zaczynal od zera i najczesciej juz ich nie zaznaczal drugi raz.
       Klucze (pod, kom0, kom1) sa pozycyjne i takie same w kazdej tkaninie,
       bo kazda ma ten sam uklad metapol dodatkow. Gdyby kolejnosc gdzies sie
       rozjechala, klient i tak widzi na kaflu nazwe i cene, wiec pomylka jest
       widoczna od razu, a nie dopiero w koszyku. */
    function addonsFromUrl() {
      var m = /[?&]ey_add=([^&]*)/.exec(window.location.search);
      if (!m) return;
      var valid = addonKeys();
      decodeURIComponent(m[1]).split(',').forEach(function (k) {
        if (k && valid.indexOf(k) !== -1) picked[k] = true;
      });
    }
    function addonsToUrl() {
      var on = addonKeys().filter(function (k) { return picked[k]; });
      return on.length ? '&ey_add=' + encodeURIComponent(on.join(',')) : '';
    }
    addonsFromUrl();

    /* Dodatek dobieramy po kolorze. Rozmiaru NIE przenosimy: poduszka 70 × 70
       nie istnieje, a fotel do kompletu ma wlasna drabinke rozmiarow. */
    function addonVariant(key) {
      var col = activeColor();
      if (!col) return null;
      var def = addonDef(key);
      if (!def) return null;
      return pickVariant(def, col, '');
    }

    root.eyExtras = function () {
      var out = [];
      addonKeys().forEach(function (k) {
        if (!picked[k]) return;
        var v = addonVariant(k);
        /* w = waga w gramach. ey-buybox.js dolicza ja do progu wysylki,
           bo paczka z lezanka to nie jest ta sama paczka co sama pufa. */
        if (v) out.push({ id: v.id, qty: 1, price: v.price, w: v.w || 0 });
      });
      return out;
    };

    function bb() {
      return (window.eyBuybox && window.eyBuybox.get) ? window.eyBuybox.get(sectionId) : null;
    }
    function pushToBuybox() {
      var inst = bb();
      if (inst && inst.refresh) inst.refresh();
      else renderSummary();
    }

    var addTiles = [].slice.call(scope().querySelectorAll('[data-ey-cfg-add]'));

    function selectedSwatchSrc() {
      var col = activeColor();
      if (!col) return '';
      var el = swatches.filter(function (b) { return norm(b.dataset.eyCfgColor) === norm(col); })[0];
      var img = el ? el.querySelector('img') : null;
      return img ? img.getAttribute('src') : '';
    }

    function renderAddons() {
      var col = activeColor();
      addTiles.forEach(function (tile) {
        var key = tile.dataset.eyCfgAdd;
        var v = addonVariant(key);
        var def = addonDef(key);
        if (!v) {
          if (picked[key]) picked[key] = false;
          tile.disabled = true;
        } else {
          tile.disabled = false;
        }
        tile.classList.toggle('is-on', !!picked[key]);
        tile.setAttribute('aria-checked', picked[key] ? 'true' : 'false');

        /* Rozmiar W NAZWIE, gdy dodatek ma wiecej niz jeden. Wczesniej kafel
           mowil tylko „Lezanka Horizont Sztruks", a pod spodem raz 520, raz
           580 zl - bo to sa dwa rozne rozmiary. Klient dokladal mebel za
           kilkaset zlotych nie wiedzac, czy bierze 120 czy 140 cm. */
        var nameEl = tile.querySelector('[data-ey-cfg-add-name]');
        if (nameEl && def) {
          var extra = '';
          if (v && v.opts && v.opts.length > 1 && col) {
            v.opts.forEach(function (o) {
              if (norm(o) !== norm(col) && !extra) extra = o;
            });
          }
          nameEl.textContent = def.title + (extra ? ' · ' + extra : '');
        }
        /* Plakietka materialu: mini probka + wymiar + tkanina + kolor.
           Prefiksy „dl./szer./wys." lecą, bo w plakietce licza sie liczby. */
        var sw = selectedSwatchSrc();
        /* SAM KOLOR, bez wymiarow i bez nazwy tkaniny. Tkanina jest jedna na
           calej karcie, a wymiary lamaly plakietke na dwa wiersze i kafle
           przestawaly byc rownej wysokosci. Zostaje to, co jest obietnica
           tego wiersza: „ten dodatek w Twoim kolorze". */
        var descEl = tile.querySelector('[data-ey-cfg-add-desc]');
        if (descEl && def) {
          var txt = esc(col || '…');
          descEl.innerHTML = sw
            ? '<img src="' + esc(sw) + '" alt="">' + txt
            : txt;
          descEl.classList.toggle('ey-cfg__add-chip--plain', !sw);
        }
        /* CENA PELNA, nie przyrost. „+59 zl" czyta sie jak doplata do pufy,
           a nie jak cena poduszki - Baymard notuje, ze brak ceny pozycji
           wypycha klienta z karty. */
        var priceEl = tile.querySelector('[data-ey-cfg-add-price]');
        if (priceEl) priceEl.textContent = v ? money(v.price) : '';
        var ctaEl2 = tile.querySelector('[data-ey-cfg-add-cta]');
        if (ctaEl2) ctaEl2.textContent = picked[key] ? 'Dodano ✓' : 'Dodaj';
        /* Kwadrat: packshot dodatku, a gdy go nie ma - probka tkaniny
           w wybranym kolorze. Plakietka z probka zostaje przy packshocie,
           zeby bylo widac, ze dodatek idzie w TYM kolorze. */
        var mediaEl = tile.querySelector('[data-ey-cfg-add-media]');
        if (mediaEl) {
          /* KOLEJNOSC ZRODEL MA ZNACZENIE. Zdjecie WARIANTU jest jedynym,
             ktore na pewno pokazuje dodatek w wybranym kolorze. Zdjecie
             produktu tego nie gwarantuje: poduszka ma jedno zdjecie w ciemnym
             kolorze, wiec przy wybranym Kremowym kafel pokazywalby zielona
             poduszke z podpisem „Kremowy". Dlatego do czasu sesji zdjeciowej
             pokazujemy probke tkaniny - mowi prawde o materiale i kolorze. */
          var shot = v && v.img ? v.img : '';
          var tag = sw ? '<span class="ey-cfg__add-tag"><img src="' + esc(sw) + '" alt=""></span>' : '';
          if (shot) {
            mediaEl.className = 'ey-cfg__add-media';
            mediaEl.innerHTML = '<img src="' + esc(shot) + '" alt="">' + tag;
          } else if (sw) {
            mediaEl.className = 'ey-cfg__add-media ey-cfg__add-media--tex';
            mediaEl.innerHTML = '<img src="' + esc(sw) + '" alt="">';
          } else {
            mediaEl.className = 'ey-cfg__add-media';
            mediaEl.innerHTML = '<span class="ey-cfg__sw-empty" aria-hidden="true"></span>';
          }
        }
      });
    }

    addTiles.forEach(function (tile) {
      tile.addEventListener('click', function () {
        if (tile.disabled) return;
        var key = tile.dataset.eyCfgAdd;
        picked[key] = !picked[key];
        renderAddons();
        /* linki tkanin i bryl niosa liste dodatkow (ey_add), wiec musza sie
           odswiezyc TAKZE przy samym zaznaczeniu dodatku, nie tylko przy
           zmianie koloru czy rozmiaru */
        syncTwinLinks();
        pushToBuybox();
      });
    });

    /* ---------- PODSUMOWANIE ---------- */
    var sumH = scope().querySelector('[data-ey-cfg-sum-h]');
    var sumN = scope().querySelector('[data-ey-cfg-sum-n]');
    var sumSw = scope().querySelector('[data-ey-cfg-sum-sw]');
    var sum1 = scope().querySelector('[data-ey-cfg-sum-1]');
    var sum2 = scope().querySelector('[data-ey-cfg-sum-2]');
    var sumA = scope().querySelector('[data-ey-cfg-sum-a]');
    var sumBase = scope().querySelector('[data-ey-cfg-sum-base]');
    var sumEx = scope().querySelector('[data-ey-cfg-sum-ex]');
    var sumWrap = scope().querySelector('.ey-cfg__sum');

    function isOrderColor() {
      var col = activeColor();
      if (!col) return false;
      var el = swatches.filter(function (b) { return norm(b.dataset.eyCfgColor) === norm(col); })[0];
      return !!(el && el.classList.contains('ey-cfg__sw--order'));
    }

    function renderSummary() {
      if (!sum1) return;
      var col = activeColor();
      var siz = activeSize();
      var g = (data.self && data.self.gender) || ['Twój produkt', 'go'];
      var inst = bb();
      var qty = inst && inst.qty ? inst.qty() : 1;

      if (sumH) sumH.textContent = g[0];

      /* Licznik mowi o SZTUKACH PUFY, dodatki liczymy osobno. Wczesniej bylo
         (1 + dodatki) * ilosc, wiec przy jednej pufie i dwoch dodatkach naglowek
         panelu brzmial „TWOJA PUFA · 3 SZTUKI" tuz nad kwota 819 zl. Klient mogl
         to przeczytac jako trzy pufy po 273 zl i zostac z tym az do dostawy. */
      var ex = root.eyExtras();
      if (sumN) {
        if (!col) {
          sumN.textContent = '';
        } else {
          var lbl = sztuk(qty);
          if (ex.length) {
            var n = ex.length, l10 = n % 10, l100 = n % 100;
            var w = (n === 1) ? 'dodatek'
              : ((l10 >= 2 && l10 <= 4 && (l100 < 12 || l100 > 14)) ? 'dodatki' : 'dodatków');
            lbl += ' + ' + n + ' ' + w;
          }
          sumN.textContent = lbl;
        }
      }

      if (sumSw) {
        var src = selectedSwatchSrc();
        sumSw.innerHTML = src
          ? '<img src="' + esc(src) + '" alt="">'
          : '<span class="ey-cfg__sw-empty" aria-hidden="true"></span>';
      }

      var bits = [data.self.title || ''];
      if (siz) bits.push(siz);
      if (col) bits.push(col);
      sum1.textContent = bits.filter(Boolean).join(' · ');

      if (sum2) {
        if (!col) {
          sum2.textContent = 'Wybierz kolor, żeby dodać do koszyka';
        } else if (isOrderColor()) {
          sum2.textContent = (data.lead && data.lead.order) || 'Kolor na zamówienie · termin potwierdzamy mailem';
        } else {
          sum2.textContent = (data.lead && data.lead.core) || 'Uszyjemy dla Ciebie w Nysie';
        }
      }

      /* Cena samego produktu w wierszu glownym. Bez niej panel pokazywal
         jedna kwote, ktora po dodaniu poduszki przestawala zgadzac sie
         z tym, co klient wybral. */
      var selfVar = ownVariant(data.self && data.self.variants, col, siz);
      if (sumBase) {
        var basePrice = (selfVar ? selfVar.price : 0) * qty;
        sumBase.textContent = basePrice > 0 ? money(basePrice) : '';
      }

      /* Dodatki jako osobne wiersze: klient widzi, z czego sklada sie suma. */
      var rows = '';
      if (sumEx) {
        addonKeys().forEach(function (k) {
          if (!picked[k]) return;
          var av = addonVariant(k);
          var ad = addonDef(k);
          if (!av || !ad) return;
          var swSrc = selectedSwatchSrc();
          rows += '<div class="ey-cfg__sum-row">'
            + '<span class="ey-cfg__sum-row-sw" aria-hidden="true">'
            + (swSrc ? '<img src="' + esc(swSrc) + '" alt="">' : '')
            + '</span>'
            + '<span class="ey-cfg__sum-row-n">' + esc(ad.title || '') + '</span>'
            + '<span class="ey-cfg__sum-row-p">' + esc(money(av.price * qty)) + '</span>'
            + '</div>';
        });
        sumEx.innerHTML = rows;
        sumEx.hidden = !rows;
      }

      /* Bez dodatkow wiersz „Razem" powtarza kwote stojaca linijke wyzej.
         To 42px drogi do przycisku za zero informacji, wiec panel zwija sie
         wtedy do naglowka i jednego wiersza (CSS: .ey-cfg__sum.is-flat). */
      if (sumWrap) sumWrap.classList.toggle('is-flat', !rows);

      if (sumA) {
        var total = 0;
        if (inst && inst.total) {
          total = inst.total();
        } else {
          total = (selfVar ? selfVar.price : 0) * qty;
          ex.forEach(function (x) { total += x.price * x.qty * qty; });
        }
        sumA.textContent = total > 0 ? money(total) : '';
      }
    }

    /* Linki bryl i tkanin liczy Liquid z opcji wybranych przy wejsciu na strone.
       Dawn przy zmianie wariantu NIE przerenderowuje bloku custom_liquid, wiec
       bez tego klient wybiera Grafit 80 × 80, klika Shaggy i laduje gdzie indziej.
       Przeliczamy hrefy z wyspy danych po kazdej zmianie. */
    function syncTwinLinks() {
      var col = activeColor();
      var siz = activeSize();
      var targets = (data.twins || []).concat(data.shapes || []);
      [].slice.call(scope().querySelectorAll('a.ey-cfg__fab')).forEach(function (a) {
        var href = a.getAttribute('href') || '';
        var t = targets.filter(function (x) { return x.url && href.indexOf(x.url) === 0; })[0];
        if (!t) return;
        /* KOLEJNOSC ODWROTU MA ZNACZENIE. Wczesniej przy braku pary
           kolor+rozmiar link spadal od razu na goly ?ey_pick=1, czyli klient
           tracil TAKZE rozmiar, ktory wybrał chwile wczesniej. Teraz kolejno:
           1) ten sam kolor i rozmiar, 2) sam rozmiar (kolor do wybrania,
           bo tamta tkanina go nie ma), 3) dopiero na koncu czysta karta. */
        var add = addonsToUrl();
        var v = pickVariant(t, col, siz);
        if (v) {
          a.setAttribute('href', t.url + '?variant=' + v.id + add);
          return;
        }
        var vs = siz ? pickVariant(t, '', siz) : null;
        if (vs) {
          a.setAttribute('href', t.url + '?variant=' + vs.id + '&ey_pick=1' + add);
          return;
        }
        a.setAttribute('href', t.url + '?ey_pick=1' + add);
      });
    }

    /* ---------- malowanie stanu ---------- */
    function paint() {
      var cur = activeColor();
      swatches.forEach(function (b) {
        var on = cur && norm(b.dataset.eyCfgColor) === norm(cur);
        b.classList.toggle('is-on', !!on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      if (nameOut) {
        if (cur) {
          var el = swatches.filter(function (b) { return norm(b.dataset.eyCfgColor) === norm(cur); })[0];
          var isOrder = el && el.classList.contains('ey-cfg__sw--order');
          nameOut.innerHTML = '';
          /* Sam kolor. Dopisek tylko wtedy, gdy niesie informacje: kolor na
             zamowienie nie ma packshotu i ma inny termin. „zdjecie" przy
             kolorze glownym nie mowilo klientowi nic, wiec wylecialo. */
          nameOut.appendChild(document.createTextNode(isOrder ? cur + ' ' : cur));
          if (isOrder) {
            var s = document.createElement('small');
            s.textContent = '· na zamówienie';
            nameOut.appendChild(s);
          }
        } else {
          nameOut.innerHTML = '<small>wybierz</small>';
        }
      }

      var siz = activeSize();
      sizeTiles.forEach(function (b) {
        var on = siz && norm(b.dataset.eyCfgSize) === norm(siz);
        b.classList.toggle('is-on', !!on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      if (sizeOut) sizeOut.textContent = siz ? siz.replace(' cm', '') : '';

      /* CTA blokujemy TYLKO w stanie wymuszonego wyboru (?ey_pick=1).
         Nigdy z powodu nieudanej detekcji natywnego selektora - to zablokowaloby
         sprzedaz na produkcie, ktory dziala poprawnie. */
      lockCta(forcePick);
      syncTwinLinks();
      renderAddons();
      renderSummary();
      renderCinfo();
    }

    /* ---------- terminy: jedno zrodlo prawdy ----------
       Okna w dniach roboczych trzyma blok „EY - Pasek dostawy" jako ustawienia
       motywu. Konfigurator je CZYTA, zamiast powtarzac liczby we wlasnym
       tekscie. Inaczej „2-3 dni" przy kolorze i data nizej na karcie
       rozjechalyby sie przy pierwszej zmianie ustawien, a klient dostalby dwie
       sprzeczne obietnice na jednej stronie. */
    function dayWord(n) {
      var l = n % 10, t = n % 100;
      return (l >= 2 && l <= 4 && (t < 12 || t > 14)) ? 'dni robocze' : 'dni roboczych';
    }
    function leadText(fast) {
      var t = data.terminy;
      if (!t || !t.kurier) return '';
      var s = fast ? t.fast : t.order;
      if (!s) return '';
      var a = (s[0] | 0) + (t.kurier[0] | 0);
      var b = (s[1] | 0) + (t.kurier[1] | 0);
      if (b <= 0) return '';
      return (a === b ? String(a) : a + '–' + b) + ' ' + dayWord(b);
    }

    /* ---------- linia statusu pod wierszem kolorow ----------
       Podzial na probki w wierszu i te pod „+14" byl dla klienta przy pierwszym
       kontakcie zagadka: nigdzie nie pisalismy, czym sie roznia ani ile bedzie
       czekal. Ta jedna linia odpowiada na oba pytania i zmienia sie razem
       z wyborem. */
    var cinfo = scope().querySelector('[data-ey-cfg-cinfo]');
    var cinfoTxt = scope().querySelector('[data-ey-cfg-cinfo-txt]');
    var cinfoIco = scope().querySelector('[data-ey-cfg-cinfo-ico]');

    function renderCinfo() {
      if (!cinfo) return;
      var cur = activeColor();
      if (!cur) { cinfo.hidden = true; return; }
      var order = isOrderColor();
      cinfo.hidden = false;
      cinfo.classList.toggle('ey-cfg__cinfo--fast', !order);
      if (cinfoIco) cinfoIco.textContent = order ? '+' : '✓';
      /* NAJPIERW zdarzenie, POTEM czytamy date. ey-buybox liczy ja synchronicznie
         w nasluchu, wiec po dispatchu element jest juz wypelniony, a my bierzemy
         DOKLADNIE ten sam napis, ktory stoi pod przyciskiem.

         Wczesniej bylo tu wlasne „U Ciebie w 3-5 dni roboczych" liczone z okien.
         Klient dostawal wtedy trzy rozne obietnice na jednym ekranie: tu widelki
         w dniach liczone od dzis, pod przyciskiem date liczona od nastepnego dnia
         roboczego (po godzinie odciecia), a na pasku zaufania jeszcze inny zakres.
         Rozjazd wynosil caly dzien roboczy. Teraz zrodlo jest jedno. */
      try {
        document.dispatchEvent(new CustomEvent('ey:cfg:color', {
          detail: { sectionId: sectionId, order: order }
        }));
      } catch (err) {}

      var txt = order
        ? 'Tkaninę w tym kolorze zwykle zamawiamy pod Ciebie.'
        : 'Ten kolor szyjemy najszybciej.';
      var etaEl = document.querySelector('[data-ey-eta]');
      var etaWrap = etaEl && etaEl.closest ? etaEl.closest('[data-ey-eta-wrap]') : null;
      var when = (etaEl && etaWrap && !etaWrap.hidden) ? (etaEl.textContent || '').trim() : '';
      if (when) txt += ' U Ciebie ' + when + '.';
      if (cinfoTxt) cinfoTxt.textContent = txt;

      syncSamplesLink(cur);
    }

    /* ---------- link do zestawu probek niesie ogladany kolor ----------
       Klient klika „nie mam pewnosci co do koloru" wtedy, gdy patrzy na
       KONKRETNY odcien. Bez tego parametru ladowal na probniku z pusta
       piatka i musial odszukac ten sam kafel wsrod czterdziestu. Probnik
       czyta ey_pre i zaznacza go za niego. */
    function syncSamplesLink(colorName) {
      var a = document.querySelector('.ey-samples');
      if (!a) return;
      var base = a.getAttribute('data-ey-base');
      if (!base) {
        base = (a.getAttribute('href') || '').split('?')[0];
        a.setAttribute('data-ey-base', base);
      }
      if (!base) return;
      var fab = (data.current && data.current.nazwa) || '';
      if (fab && colorName) {
        a.setAttribute('href', base + '?ey_pre=' + encodeURIComponent(fab + ' · ' + colorName));
      } else {
        a.setAttribute('href', base);
      }
    }

    /* Uchwyty wiersza kolorow. Przypisuje je nizej blok „kolory na zamowienie";
       tutaj stoja po to, zeby obsluga kliku w probke mogla ich uzyc, zanim ten
       blok sie wykona (klik zdarza sie i tak dopiero po calym init). */
    var cfgCoreRow = null, cfgMoreBtn = null, cfgOrderSheet = null, cfgMoreN = null, cfgMoreT = null, cfgSheetH = null;
    function colorWord(n) {
      var l = n % 10, t = n % 100;
      return (l >= 2 && l <= 4 && (t < 12 || t > 14)) ? 'kolory' : 'kolorów';
    }
    function syncMoreCount() {
      if (!cfgMoreBtn || !cfgOrderSheet) return;
      var left = cfgOrderSheet.querySelectorAll('[data-ey-cfg-color]').length;
      if (cfgMoreN) cfgMoreN.textContent = '+' + left;
      if (cfgMoreT) cfgMoreT.textContent = colorWord(left) + ' na zamówienie';
      if (cfgSheetH) cfgSheetH.textContent = left + ' ' + colorWord(left) + ' na zamówienie';
      cfgMoreBtn.hidden = left === 0;
    }

    swatches.forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.hasAttribute('disabled')) return;
        forcePick = false;
        setOption(colorOption, b.dataset.eyCfgColor);
        /* Probka klikneta w arkuszu kolorow na zamowienie. Decyzja zapadla,
           wiec arkusz sie zamyka - ale NAJPIERW przenosimy ten kafel do
           wiersza glownego. Inaczej po zamknieciu arkusza w wierszu nie byloby
           widac NIC zaznaczonego, bo wybrana probka zostalaby schowana. */
        if (b.closest && b.closest('.ey-sheet')) {
          if (cfgCoreRow) { cfgCoreRow.appendChild(b); syncMoreCount(); }
          closeSheet();
        }
        paint();
        pushToBuybox();
      });
    });

    sizeTiles.forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.disabled) return;
        setOption(sizeOption, b.dataset.eyCfgSize);
        paint();
        pushToBuybox();
      });
    });

    /* natywna zmiana wariantu (np. przez historie) tez odswieza UI */
    document.addEventListener('change', function (e) {
      if (!e.target || !e.target.matches) return;
      if (e.target.matches('input[name="id"], input[type="radio"], select')) {
        if (!forcePick) paint();
      }
    });

    /* ey-buybox przeliczyl cene/ilosc -> podsumowanie idzie za nim, nigdy obok */
    document.addEventListener('ey:buybox:render', function (e) {
      if (!e.detail || e.detail.sectionId !== sectionId) return;
      renderSummary();
    });

    /* ---------- arkusze: bottom sheet na telefonie, dialog na desktopie ----------
       Jeden mechanizm dla asystenta tkaniny i dla kolorow na zamowienie. Oba
       byly wczesniej kartami w kolumnie i razem kosztowaly ~136px drogi do
       przycisku u KAZDEGO klienta, takze u tego, ktory ich nie potrzebowal.

       PANEL LADZIE W <body>. .product__info-container potrafi siedziec
       w kontenerze z transformem, a wtedy position:fixed przestaje byc liczone
       wzgledem okna i arkusz wyladowalby w polowie strony. Przenosimy wezel
       raz, przy pierwszym otwarciu; nasluchy sa na elementach, wiec przenosiny
       niczego nie zrywaja.

       PRZYCISK WSTECZ CELOWO NIE ZAMYKA ARKUSZA, choc NN/g to zaleca. Dawn przy
       zmianie wariantu robi history.replaceState, wiec wpis dolozony przy
       otwarciu arkusza zostalby nadpisany adresem nowego wariantu, a history.back()
       po wyborze koloru cofnelby klientowi wlasnie dokonany wybor. Zostaje
       krzyzyk, tlo i Esc - kazde widoczne, zadne nie polega na samym gescie. */
    var openSheetEl = null;
    var sheetTrigger = null;

    function sheetKey(e) {
      if (e.key === 'Escape' || e.keyCode === 27) { closeSheet(); return; }
      if (e.key !== 'Tab' || !openSheetEl) return;
      var f = openSheetEl.querySelectorAll('button:not([disabled]),a[href],[tabindex]:not([tabindex="-1"])');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    function closeSheet() {
      var el = openSheetEl;
      if (!el) return;
      openSheetEl = null;
      el.classList.remove('is-open');
      document.body.classList.remove('ey-sheet-lock');
      document.removeEventListener('keydown', sheetKey);
      window.setTimeout(function () {
        if (!el.classList.contains('is-open')) el.hidden = true;
      }, 240);
      if (sheetTrigger) {
        sheetTrigger.setAttribute('aria-expanded', 'false');
        try { sheetTrigger.focus({ preventScroll: true }); } catch (err) {}
        sheetTrigger = null;
      }
    }

    function openSheet(el, trigger) {
      if (!el || openSheetEl === el) return;
      if (el.parentNode !== document.body) document.body.appendChild(el);
      openSheetEl = el;
      sheetTrigger = trigger || null;
      el.hidden = false;
      document.body.classList.add('ey-sheet-lock');
      /* jedna klatka zwloki, zeby przegladarka zdazyla policzyc stan
         poczatkowy - bez tego panel przeskakuje zamiast wjezdzac */
      window.requestAnimationFrame(function () { el.classList.add('is-open'); });
      document.addEventListener('keydown', sheetKey);
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      var panel = el.querySelector('.ey-sheet__panel');
      if (panel) {
        panel.setAttribute('tabindex', '-1');
        try { panel.focus({ preventScroll: true }); } catch (err) {}
      }
    }

    function wireSheet(el) {
      if (!el) return;
      el.addEventListener('click', function (e) { if (e.target === el) closeSheet(); });
      el.querySelectorAll('[data-ey-sheet-close]').forEach(function (b) {
        b.addEventListener('click', closeSheet);
      });
    }

    /* ---------- kolory na zamowienie ---------- */
    var moreBtn = scope().querySelector('[data-ey-cfg-more]');
    var orderSheet = scope().querySelector('[data-ey-cfg-order]');
    if (moreBtn && orderSheet) {
      wireSheet(orderSheet);
      moreBtn.addEventListener('click', function () { openSheet(orderSheet, moreBtn); });

      /* Klient wszedl na wariant w kolorze na zamowienie (link, podpowiedz
         asystenta, powrot z koszyka). Jego probka lezy w arkuszu, wiec
         w wierszu nie byloby widac NIC zaznaczonego. Przenosimy ten jeden
         kafel do wiersza glownego. Wczesniej rozwiazywalo to automatyczne
         rozwiniecie listy - teraz oznaczaloby otwarcie okna na wejsciu,
         czego nie robimy nigdy. */
      cfgCoreRow = scope().querySelector('[data-ey-cfg-sws-core]');
      cfgMoreBtn = moreBtn;
      cfgOrderSheet = orderSheet;
      cfgMoreN = moreBtn.querySelector('[data-ey-cfg-more-n]');
      cfgMoreT = moreBtn.querySelector('[data-ey-cfg-more-t]');
      cfgSheetH = orderSheet.querySelector('[data-ey-cfg-sheet-h]');

      var curNow = currentOf(colorOption);
      var curEl = swatches.filter(function (b) { return norm(b.dataset.eyCfgColor) === norm(curNow); })[0];
      if (!forcePick && cfgCoreRow && curEl && curEl.classList.contains('ey-cfg__sw--order') && curEl.closest('.ey-sheet')) {
        cfgCoreRow.appendChild(curEl);
      }
      syncMoreCount();

      /* Terminy w wyjasnieniu bierzemy z paska dostawy, nie z tekstu w Liquidzie */
      orderSheet.querySelectorAll('[data-ey-lead]').forEach(function (el) {
        var t = leadText(el.dataset.eyLead === 'fast');
        var v = el.querySelector('[data-ey-lead-v]');
        if (t && v) { v.textContent = t; el.hidden = false; }
      });

      /* Klient bez zdjecia produktu ma jedno realne wyjscie: zobaczyc material
         u siebie. Arkusz sie zamyka i zjezdzamy do bloku z probkami. */
      var toSamples = orderSheet.querySelector('[data-ey-cfg-to-samples]');
      if (toSamples) {
        toSamples.addEventListener('click', function () {
          closeSheet();
          var s = document.querySelector('.ey-samples');
          if (!s) return;
          window.setTimeout(function () {
            s.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }, 260);
        });
      }
    }

    /* ---------- asystent tkaniny ----------
       Wyzwalacz stoi teraz w naglowku wiersza TKANINA (pigulka „Dobierz za
       mnie"), a tresc w arkuszu. Oba warunki renderowania sa te same po
       stronie Liquida, ale gdyby kiedys sie rozjechaly, pigulka bez arkusza
       ma zniknac, a nie prowadzic donikad. */
    var assist = scope().querySelector('[data-ey-cfg-assist]');
    var assistBtn = scope().querySelector('[data-ey-cfg-assist-toggle]');
    if (assist && !assistBtn) assist.hidden = true;
    if (assistBtn && !assist) assistBtn.hidden = true;
    if (assist && assistBtn) {
      wireSheet(assist);
      var reco = assist.querySelector('[data-ey-cfg-reco]');

      /* ---------- kreator: jeden krok na ekran ----------
         Oba pytania naraz mialy ~600px. Na telefonie drugie ladowalo pod dolna
         krawedzia ekranu, przykryte paskiem „Dodaj do koszyka", wiec klient
         odpowiadal na pierwsze i utykal. Teraz arkusz przykleja sie do
         wysokosci jednego kroku: pytanie 1, pytanie 2, wynik. */
      var stepEls = [].slice.call(assist.querySelectorAll('[data-ey-cfg-step]'));
      var backBtn = assist.querySelector('[data-ey-cfg-back]');
      var stage = 1;

      function showStage(n) {
        stage = n;
        stepEls.forEach(function (s) {
          s.hidden = (parseInt(s.dataset.eyCfgStep, 10) || 0) !== n;
        });
        if (reco) reco.hidden = n !== 3;
        if (backBtn) backBtn.hidden = n === 1;
        var body = assist.querySelector('.ey-sheet__body');
        if (body) body.scrollTop = 0;
      }

      if (backBtn) {
        backBtn.addEventListener('click', function () {
          showStage(stage > 1 ? stage - 1 : 1);
        });
      }
      var answers = {};

      var allFabrics = function () {
        return [data.current].concat(data.twins || []);
      };

      /* ---------- kubelki tonow ----------
         Metapole „tony" opisuje tylko czesc palety (w sztruksie 11 z 20
         kolorow), wiec dziewiec kolorow bylo dla asystenta niewidzialnych,
         takze przy odpowiedzi „chce najwiekszy wybor kolorow". Reszte
         doliczamy jako kubelek „Kolorowe" z pelnej listy kolorow tkaniny.
         Tony, ktorych dana tkanina nie ma, w ogole sie nie pokazuja - klient
         nie klika w slepa uliczke. */
      var TONE_ORDER = [
        ['jasny', 'Jasny'], ['braz', 'Brąz'], ['szary', 'Szary'], ['czarny', 'Czarny']
      ];
      function toneBuckets(fab) {
        var tones = parseTones(fab.tony);
        var all = (fab.kolory || []).slice();
        var known = {};
        all.forEach(function (c) { known[norm(c)] = c; });
        var used = {};
        var out = [];
        TONE_ORDER.forEach(function (t) {
          var vals = (tones[t[0]] || []).filter(function (c) {
            return !all.length || known[norm(c)];
          });
          if (!vals.length) return;
          vals.forEach(function (c) { used[norm(c)] = 1; });
          out.push({ key: t[0], label: t[1], colors: vals });
        });
        var rest = all.filter(function (c) { return !used[norm(c)]; });
        /* „Kolorowy", nie „Kolorowe" - pytanie brzmi „w jakim tonie", wiec
           odpowiedzi sa w tym samym przypadku co Jasny, Braz, Szary, Czarny. */
        if (rest.length) out.push({ key: 'kolorowe', label: 'Kolorowy', colors: rest });
        return out;
      }
      /* Kropka na przycisku tonu: realna probka materialu. Mamy ja tylko dla
         tkaniny, ktora jest na tej karcie - przy pozostalych przycisk zostaje
         sam tekst, zamiast udawac kolor, ktorego nie znamy. */
      function swatchFor(colorName) {
        var el = swatches.filter(function (b) { return norm(b.dataset.eyCfgColor) === norm(colorName); })[0];
        var img = el ? el.querySelector('img') : null;
        return img ? img.getAttribute('src') : '';
      }
      /* WSZYSTKIE tony, jakie istnieja w calej rodzinie tkanin - nie tylko te,
         ktore ma wybrana tkanina. Wczesniej pokazywalismy sam przekroj i przy
         Shaggy piaty przycisk po prostu znikal. Z punktu widzenia klienta
         wygladalo to na blad, a bylo faktem o produkcie: Shaggy jest tylko
         w pieciu odcieniach naturalnych. Roznica jest taka, ze fakt trzeba
         POWIEDZIEC, a nie schowac. Baymard o wariantach: opcje niedostepne
         maja byc widoczne i oznaczone, nie usuwane z listy. */
      function allToneKeys() {
        var seen = {};
        allFabrics().forEach(function (f) {
          toneBuckets(f).forEach(function (b) { seen[b.key] = b.label; });
        });
        var out = [];
        TONE_ORDER.forEach(function (t) { if (seen[t[0]]) out.push({ key: t[0], label: t[1] }); });
        if (seen.kolorowe) out.push({ key: 'kolorowe', label: seen.kolorowe });
        return out;
      }

      var tonesBox = assist.querySelector('[data-ey-cfg-tones]');
      var tonesFab = null;
      function renderTones(fab) {
        if (!tonesBox) return;
        tonesFab = fab;
        var isCur = fab.url === data.current.url;
        var have = {};
        toneBuckets(fab).forEach(function (b) { have[b.key] = b; });
        var html = '';
        allToneKeys().forEach(function (t) {
          var b = have[t.key];
          var sw = (isCur && b) ? swatchFor(b.colors[0]) : '';
          html += '<button type="button" class="ey-cfg__tone' + (b ? '' : ' ey-cfg__tone--none')
            + '" data-v="' + esc(t.key) + '"' + (b ? '' : ' data-none="1"') + '>'
            + (sw ? '<span class="ey-cfg__tone-dot"><img src="' + esc(sw) + '" alt=""></span>' : '')
            + esc(t.label)
            + (b ? '' : '<small>brak w tej tkaninie</small>') + '</button>';
        });
        tonesBox.innerHTML = html;
        tonesBox.querySelectorAll('button').forEach(function (btn) {
          btn.addEventListener('click', function () {
            tonesBox.querySelectorAll('button').forEach(function (x) { x.classList.remove('is-on'); });
            btn.classList.add('is-on');
            answers.ton = btn.dataset.v;
            /* Ton, ktorego ta tkanina nie ma, to nie slepa uliczka tylko
               najlepszy moment na podpowiedz: ktora tkanina go ma. */
            if (btn.dataset.none) { renderRecoNoTone(tonesFab, btn.dataset.v, btn.textContent.replace('brak w tej tkaninie', '').trim()); return; }
            renderReco();
          });
        });
      }

      /* Wybrana tkanina nie ma tego tonu. Mowimy wprost, w ilu odcieniach ja
         mamy, i pokazujemy tkanine, ktora ten ton ma - z najwieksza liczba
         odcieni w tym tonie. */
      function renderRecoNoTone(fab, toneKey, toneLabel) {
        function bucketOf(f) {
          return toneBuckets(f).filter(function (b) { return b.key === toneKey; })[0] || null;
        }
        var alt = allFabrics().filter(function (f) {
          return f.url !== fab.url && bucketOf(f);
        }).sort(function (a, b) {
          return (bucketOf(b).colors.length) - (bucketOf(a).colors.length);
        })[0] || null;

        var own = (fab.kolory || []);
        var html = '<div class="ey-cfg__reco-card"><span class="ey-cfg__reco-sw">'
          + (fab.probka ? '<img src="' + esc(fab.probka) + '" alt="">' : '')
          + '</span><span class="ey-cfg__reco-txt"><b>' + esc(fab.nazwa) + ' nie ma tego odcienia</b>'
          + (own.length ? '<small>Mamy ' + (own.length === 1 ? 'go w 1 odcieniu: ' : 'go w ' + own.length + ' odcieniach: ') + esc(own.join(', ')) + '.</small>' : '')
          + '</span></div>';

        if (alt) {
          var an = bucketOf(alt).colors.length;
          var word = (an === 1) ? 'odcień' : ((an % 10 >= 2 && an % 10 <= 4 && (an % 100 < 12 || an % 100 > 14)) ? 'odcienie' : 'odcieni');
          html += '<div class="ey-cfg__reco-txt" style="margin-bottom:10px"><small>'
            + esc(toneLabel) + ' ma za to ' + esc(alt.nazwa) + ': ' + an + ' ' + word + ' do wyboru.</small></div>';
          var v = pickVariant(alt, '', activeSize());
          var href = alt.url + (v ? '?variant=' + v.id + '&ey_pick=1' : '?ey_pick=1') + addonsToUrl();
          html += '<a class="ey-cfg__reco-go" href="' + esc(href) + '" style="text-align:center;text-decoration:none">Zobacz ' + esc(alt.nazwa) + '</a>';
        }
        html += '<button type="button" class="ey-cfg__reco-skip" data-ey-cfg-reton>Wybiorę inny odcień</button>';
        reco.innerHTML = html;
        showStage(3);
        var re = reco.querySelector('[data-ey-cfg-reton]');
        if (re) re.addEventListener('click', function () { showStage(2); });
      }

      function renderRecoNoFab() {
        reco.innerHTML = '<div class="ey-cfg__reco-txt"><small>W tej bryle nie mamy tkaniny pod tę potrzebę. Zestaw próbek pomoże wybrać.</small></div>';
        showStage(3);
      }

      var renderReco = function () {
        if (!answers.cel || !answers.ton) { reco.hidden = true; return; }
        var pick = allFabrics().filter(function (f) { return norm(f.key) === norm(answers.cel); })[0];
        if (!pick) { renderRecoNoFab(); return; }
        var core = splitList(pick.core);
        var bucket = toneBuckets(pick).filter(function (b) { return b.key === norm(answers.ton); })[0];
        var candidates = bucket ? bucket.colors : [];
        /* Z kubelka bierzemy kolor, ktory MA packshot (jest w kolory_glowne).
           Dopiero gdy takiego nie ma, schodzimy na pierwszy z brzegu, czyli
           kolor na zamowienie - i wtedy klient i tak zobaczy przy nim dluzszy
           termin, bo linia statusu reaguje na wybor. */
        var color = candidates.filter(function (c) {
          return core.some(function (k) { return norm(k) === norm(c); });
        })[0] || candidates[0] || null;

        var isCurrent = pick.url === data.current.url;
        var diff = pick.price - data.current.price;
        var showPrice = pick.price > 0 && data.current.price > 0;
        var priceTxt = isCurrent ? 'to tkanina, którą oglądasz'
          : (!showPrice ? ''
            : (diff > 0 ? 'dopłata ' + money(diff) + ' do ceny bryły'
              : (diff < 0 ? money(Math.abs(diff)) + ' taniej' : 'w tej samej cenie')));

        var html = '<div class="ey-cfg__reco-card">' +
          '<span class="ey-cfg__reco-sw">' +
          (pick.probka ? '<img src="' + esc(pick.probka) + '" alt="">' : '') +
          '</span><span class="ey-cfg__reco-txt"><b>' + esc(pick.nazwa) +
          (color ? ' · ' + esc(color) : '') + '</b>' +
          (pick.opis ? '<small>' + esc(pick.opis) + '</small>' : '') +
          (priceTxt ? '<small>' + esc(priceTxt) + '</small>' : '') + '</span></div>';

        if (isCurrent && color) {
          html += '<button type="button" class="ey-cfg__reco-go" data-ey-cfg-set="' + esc(color) + '">Ustaw kolor ' + esc(color) + '</button>';
        } else if (!isCurrent) {
          var href = pick.url;
          var v = pickVariant(pick, color, activeSize());
          var vs2 = v || (activeSize() ? pickVariant(pick, '', activeSize()) : null);
          href += vs2 ? '?variant=' + vs2.id + (v ? '' : '&ey_pick=1') : '?ey_pick=1';
          href += addonsToUrl();
          html += '<a class="ey-cfg__reco-go" href="' + esc(href) + '" style="text-align:center;text-decoration:none">Zobacz ' + esc(pick.nazwa) + (color ? ' w kolorze ' + esc(color) : '') + '</a>';
        }
        html += '<button type="button" class="ey-cfg__reco-skip" data-ey-cfg-skip>Zostaję przy swoim</button>';

        reco.innerHTML = html;
        showStage(3);

        var setBtn = reco.querySelector('[data-ey-cfg-set]');
        if (setBtn) {
          setBtn.addEventListener('click', function () {
            forcePick = false;
            setOption(colorOption, setBtn.dataset.eyCfgSet);
            paint();
            pushToBuybox();
            closeSheet();
          });
        }
        var skip = reco.querySelector('[data-ey-cfg-skip]');
        if (skip) skip.addEventListener('click', closeSheet);
      };

      assistBtn.addEventListener('click', function () {
        /* ZAWSZE od pierwszego pytania. Wczesniej klient z kompletem odpowiedzi
           dostawal od razu poprzedni wynik - a skoro klika „Dobierz za mnie"
           drugi raz, to najczesciej dlatego, ze chce zmienic zdanie, nie
           zobaczyc to samo. Musial sie domyslic, ze trzeba dwa razy „Wstecz". */
        showStage(1);
        openSheet(assist, assistBtn);
      });

      /* Krok 1 jest statyczny (cztery potrzeby), krok 2 buduje sie dynamicznie
         pod wybrana tkanine, wiec bindujemy tu tylko pierwsza grupe. */
      var celBox = assist.querySelector('[data-ey-cfg-q="cel"]');
      if (celBox) {
        var group = celBox;
        group.querySelectorAll('button').forEach(function (btn) {
          btn.addEventListener('click', function () {
            group.querySelectorAll('button').forEach(function (x) { x.classList.remove('is-on'); });
            btn.classList.add('is-on');
            answers[group.dataset.eyCfgQ] = btn.dataset.v;
            var fab = allFabrics().filter(function (f) { return norm(f.key) === norm(answers.cel); })[0];
            if (!fab) { answers.ton = ''; renderRecoNoFab(); return; }
            renderTones(fab);
            /* ton z poprzedniego przebiegu moze nie istniec w tej tkaninie */
            if (answers.ton && !toneBuckets(fab).some(function (b) { return b.key === norm(answers.ton); })) {
              answers.ton = '';
            }
            /* pierwsza odpowiedz przesuwa do drugiego pytania; jesli klient
               wraca i zmienia zdanie, komplet odpowiedzi idzie prosto na wynik */
            if (!answers.ton) { showStage(2); return; }
            renderReco();
          });
        });

        /* Potrzeba bez pokrycia w zadnej AKTYWNEJ tkaninie znika z pytania.
           Kroki asystenta sa statyczne w Liquidzie, a lista tkanin nie: po
           wylaczeniu tkaniny z konfiguratora jej odpowiedz („najwiekszy wybor
           kolorow" nalezala do Sztruksu) prowadzilaby klienta w slepa uliczke.
           Pytanie ma wymieniac tylko te potrzeby, ktore umiemy zaspokoic. */
        var haveKeys = {};
        allFabrics().forEach(function (f) { if (f && f.key) haveKeys[norm(f.key)] = 1; });
        group.querySelectorAll('button').forEach(function (btn) {
          btn.hidden = !haveKeys[norm(btn.dataset.v)];
        });
      }

      showStage(1);
    }

    hideNativeFields();
    numberSteps();
    watchNative();
    paint();
  }

  function initAll(where) {
    var root = where || document;
    if (!root.querySelectorAll) return;
    root.querySelectorAll('[data-ey-cfg]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();